var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: function() {
            return (_vm.open = false)
          },
          expression: "() => (open = false)"
        }
      ],
      staticClass:
        "slide fixed z-100 left-[-100vw] lg:left-auto lg:right-[-100vw] xl:right-auto xl:left-[-73vw] hidden lg:flex flex-row transition-all",
      class: { "!left-0 !lg:right-0 !xl:left-0": _vm.open }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "contact-fly-out fly-out-body w-[100vw] xl:w-[73vw] bg-brown-400 h-[100vh] p-16 lg:p-[75px] xl:p-[150px] overflow-y-auto"
        },
        [
          _c("div", { staticClass: "relative" }, [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.svg("liberoo", "h-[38px] mb-[40px]"))
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "far fa-times text-white absolute right-0 top-0 cursor-pointer text-20",
              on: {
                click: function($event) {
                  _vm.open = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-white mb-[72px] flex justify-between items-end"
            },
            [
              _c("div", { staticClass: "flex flex-wrap gap-32" }, [
                _vm.address
                  ? _c("div", {
                      staticClass: "max-w-[150px]",
                      domProps: { innerHTML: _vm._s(_vm.address) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _vm.email
                    ? _c("a", { attrs: { href: "mailto:" + _vm.email } }, [
                        _c("span", { staticClass: "text-orange" }, [
                          _vm._v("E:")
                        ]),
                        _vm._v(" " + _vm._s(_vm.email))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.phone
                    ? _c("a", { attrs: { href: "tel:" + _vm.phone } }, [
                        _c("span", { staticClass: "text-orange" }, [
                          _vm._v("T:")
                        ]),
                        _vm._v(" " + _vm._s(_vm.phone))
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "block bg-orange text-white px-[24px] py-[14px] rounded-full text-20 font-semi hover:opacity-75 transition-opacity",
                  attrs: { href: "/contact" }
                },
                [_vm._v("contacteer ons")]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "text-white text-40 font-extraBold mb-[39px]" },
              [_vm._v("Onze kantoren")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-32"
              },
              [
                _vm._l(_vm.localOffices, function(office) {
                  return _c(
                    "div",
                    {
                      key: office.id,
                      staticClass:
                        "flex flex-col gap-8 group pb-16 border-b border-brown-300 relative"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "text-orange text-20 font-semi",
                          attrs: { href: office.link }
                        },
                        [_vm._v(_vm._s(office.title.rendered))]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "block text-white font-regular",
                            attrs: { href: "mailto:" + office.acf.email }
                          },
                          [
                            _c("span", { staticClass: "text-orange" }, [
                              _vm._v("E:")
                            ]),
                            _vm._v(" " + _vm._s(office.acf.email))
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "block text-white font-regular group",
                            attrs: { href: "tel:" + office.acf.phone }
                          },
                          [
                            _c("span", { staticClass: "text-orange" }, [
                              _vm._v("T:")
                            ]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(office.acf.phone) +
                                "\n                        "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("a", {
                        staticClass:
                          "fas fa-chevron-right text-14 text-white group-hover:right-0 transition-all absolute right-16 top-8",
                        attrs: { href: office.link }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.links, function(link, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "flex flex-col gap-8 group pb-16 border-b border-brown-300 relative"
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "text-orange text-20 font-semi" },
                        [_vm._v(_vm._s(link.title))]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass:
                              "block text-white font-regular whitespace-nowrap overflow-x-hidden w-full overflow-ellipsis",
                            attrs: { href: "mailto:" + link.email }
                          },
                          [
                            _c("span", { staticClass: "text-orange" }, [
                              _vm._v("E:")
                            ]),
                            _vm._v(" " + _vm._s(link.email))
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "block text-white font-regular group",
                            attrs: { href: "tel:" + link.phone }
                          },
                          [
                            _c("span", { staticClass: "text-orange" }, [
                              _vm._v("T:")
                            ]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(link.phone) +
                                "\n                        "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "contact-fly-out fly-out-button bg-orange text-white flex gap-8 font-regular text-20 px-24 py-[14px] -rotate-90 lg:rotate-90 xl:-rotate-90 origin-top-right lg:origin-top-left xl:origin-top-right cursor-pointer absolute top-[30vh] xl:top-[50vh] right-[1px] lg:left-[1px] lg:right-auto xl:left-auto xl:right-[1px]",
          on: {
            click: function($event) {
              _vm.open = !_vm.open
            }
          }
        },
        [
          _c("span", { staticClass: "mr-8" }, [_vm._v("contact")]),
          _vm._v(" "),
          _c("i", { staticClass: "far fa-phone rotate-90" }),
          _vm._v(" "),
          _c("i", { staticClass: "far fa-envelope rotate-90" })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }